<div class="viewerNavWrapper">
  <div class="sr-only"
   aria-live="polite"
   aria-atomic="true">
{{ navAnnouncement }}
  </div>
  <span class="align-self-center"><h2 class="viewer-nav-label">Materials in this collection</h2></span>
  <div class="nav-content">
    <span class="previous-content h6 my-0" data-cy="viewer-header-title" [attr.aria-label]="'previous material ' + previousDescriptionText" [innerHTML]="previousDescription"></span>
    <div class="vertical-separator"></div>
    <span class="next-content h6 my-0" data-cy="viewer-header-title" [attr.aria-label]="'next material ' + nextDescriptionText" [innerHTML]="nextDescription"></span>
  </div>
  <div class="viewer-nav-buttons">
    <div class="viewer-nav-button">
      <zbp-button-component id="navPrevious"
                            type="button"
                            [label]="'Previous'"
                            [ariaLabel]="'Previous Material'"
                            [disabled]="!hasPrevious"
                            (click)="togglePrevious()"
                            [theme]="'blackText'"
                            [iconSize]="'font-size'"
                            [iconPosition]="'left'"
                            [iconName]="zbpIconNames.arrow_chevron_left">
      </zbp-button-component>
    </div>
    <div class="nav-page-numbers">
      <div>
        {{pageInfo?.page}}
      </div>
      <div>
        of
      </div>
      <div>
        {{pageInfo?.pages}}
      </div>
    </div>
    <div class="viewer-nav-button">
      <zbp-button-component id="navNext"
                            type="button"
                            [label]="'Next'"
                            [ariaLabel]="'Next Material'"
                            [disabled]="!hasNext"
                            (click)="toggleNext()"
                            [theme]="'blackText'"
                            [iconSize]="'font-size'"
                            [iconPosition]="'right'"
                            [iconName]="zbpIconNames.arrow_chevron_right">
      </zbp-button-component>
    </div>
  </div>
</div>
